import { PRIVATE_CONTROLLERS } from "../controllers/private-controllers";
export var stylableOptions = {
    sections: [
        {
            states: [
                PRIVATE_CONTROLLERS.STYLABLE.CONTAINER,
            ],
            children: [
                {
                    states: [
                        PRIVATE_CONTROLLERS.STYLABLE.ITEM,
                        PRIVATE_CONTROLLERS.STYLABLE.ITEM_HOVER,
                    ],
                    children: [
                        {
                            states: [
                                PRIVATE_CONTROLLERS.STYLABLE.ITEM_CONTENT,
                                PRIVATE_CONTROLLERS.STYLABLE.ITEM_CONTENT_HOVER,
                            ],
                            children: [
                                {
                                    states: [
                                        PRIVATE_CONTROLLERS.STYLABLE.INNER_TITLE,
                                    ],
                                    children: []
                                },
                                {
                                    states: [
                                        PRIVATE_CONTROLLERS.STYLABLE.INNER_TITLE_REGULAR,
                                        PRIVATE_CONTROLLERS.STYLABLE.INNER_TITLE_HOVER,
                                    ],
                                    children: []
                                },
                                {
                                    states: [
                                        PRIVATE_CONTROLLERS.STYLABLE.INNER_DESCRIPTION,
                                    ],
                                    children: []
                                },
                                {
                                    states: [
                                        PRIVATE_CONTROLLERS.STYLABLE.INNER_DESCRIPTION_REGULAR,
                                        PRIVATE_CONTROLLERS.STYLABLE.INNER_DESCRIPTION_HOVER,
                                    ],
                                    children: []
                                },
                            ]
                        },
                        {
                            states: [
                                PRIVATE_CONTROLLERS.STYLABLE.ITEM_OVERLAY,
                                PRIVATE_CONTROLLERS.STYLABLE.ITEM_OVERLAY_HOVER,
                            ],
                            children: []
                        },
                        {
                            states: [
                                PRIVATE_CONTROLLERS.STYLABLE.EXTERNAL_TITLE,
                            ],
                            children: []
                        },
                        {
                            states: [
                                PRIVATE_CONTROLLERS.STYLABLE.EXTERNAL_TITLE_REGULAR,
                                PRIVATE_CONTROLLERS.STYLABLE.EXTERNAL_TITLE_HOVER,
                            ],
                            children: []
                        },
                        {
                            states: [
                                PRIVATE_CONTROLLERS.STYLABLE.EXTERNAL_DESCRIPTION,
                            ],
                            children: []
                        },
                        {
                            states: [
                                PRIVATE_CONTROLLERS.STYLABLE.EXTERNAL_DESCRIPTION_REGULAR,
                                PRIVATE_CONTROLLERS.STYLABLE.EXTERNAL_DESCRIPTION_HOVER,
                            ],
                            children: []
                        }
                    ]
                },
                {
                    states: [
                        PRIVATE_CONTROLLERS.STYLABLE.LOAD_MORE,
                    ],
                    children: []
                },
            ]
        },
    ],
    initial: PRIVATE_CONTROLLERS.STYLABLE.CONTAINER,
};
//# sourceMappingURL=stylableOptions.js.map